// @flow

import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html, body, #tectonics {
    font-size: ${props => props.theme.fontSize};
    font-family: ${props => props.theme.fontFamily.sansSerif};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  * {
    font-size: inherit;
    font-family: inherit;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  body {
    background: ${props => props.theme.colors.gray(89)};
  }
`;
